import React, { Component } from 'react'
import Slider from "react-slick"

import ObjPushThematiqueFormation from './ObjPushThematiqueFormation'
import { throttle, isMobile } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"

import '../../assets/css/0020_objects/0710_obj_carousel_formation.css'
import '../../assets/css/0020_objects/0720_obj_list_pushs_thematique_formation.css'

class ObjListPushsThematiqueFormation extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile(),
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
	}

	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}

	componentDidMount() {
        window.addEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
	}

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: true,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
            dots: true,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: false,
            speed: 750,
        };

        const { datasThemes } = this.props;

		return (<>{datasThemes && <>
			<div className="obj_list_pushs_thematique_formation">
                
				<div className="ctn_title">
					<h2 className="t_title">Formez-vous sur une thématique :</h2>
				</div>

				{ this.state.isMobile &&
					<div className="ctn_carrousel">
						<Slider {...settings} ref={sliderRef}>
							{ datasThemes.map((datasTheme, index) => (
								<div className="item" key={index}>
									<ObjPushThematiqueFormation datasTheme={datasTheme}/>
								</div>
							))}
						</Slider>
					</div>
				}
				
				{!this.state.isMobile &&
					<div className="ctn_row">
						{ datasThemes.map((datasTheme, index) => (
							<ObjPushThematiqueFormation key={index} datasTheme={datasTheme}/>
						))}
					</div>
				}

			</div>
        </>}</>)
	}
}

export default ObjListPushsThematiqueFormation